import { useEffect, useState } from "react";
import { OrderContent } from "../../order/OrderList";
import { templateTransactionData } from "../../../data/order/transactionTableData";
import CommonPaginationSection from "../../common/CommonPaginationSection";
import getTransactions from "../../../controllers/booking/Transactions.js/getTransactions";
import getWalletTransactions from "../../../controllers/booking/Transactions.js/getWalletTransactions";

function CustomerDetailTransactionList({ tab, data }) {
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);

  const loadData = async () => {
    setLoading(true);
    const query = {
      limit: pagination.perPage,
      offset: (pagination.page - 1) * pagination.perPage,
    };
    // query.filterBy = "account";
    // query.filterValue = data?._id;
    // if (tab === "wallet") {
    // }
    // if (tab === "wallet") {
    //   query.searchBy = "paymentMode";
    //   // query.keyword = "wallet,virtualaccount";
    //   query.keyword = "wallet";
    //   query.filterBy = "status";
    //   query.filterValue = "Success";
    // }
    const res = await (
      tab === "wallet" ? getWalletTransactions : getTransactions
    )(new URLSearchParams(query)?.toString(), data?._id).finally(() =>
      setLoading(false),
    );
    if (res?.return) {
      setOgData(res?.data?.data);
      setOrders(
        res?.data?.data?.map((item) =>
          templateTransactionData(item, tab === "wallet"),
        ),
      );
      setPagination({ ...pagination, total: res?.data?.meta?.total || 10 });
    }
  };

  useEffect(() => {
    loadData();
  }, [pagination.page, pagination.perPage, tab]);

  if (loading)
    return (
      <div className="w-full flex items-center justify-center py-4">
        <div className="primaryLoader"></div>
      </div>
    );

  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex flex-col mt-4 bg-[#F0F6FC] gap-2 p-1 rounded-md">
        {orders.map((order, index) => (
          <Order key={index} order={order} og={ogData?.at(index)} />
        ))}
      </div>
      <CommonPaginationSection
        perPage={pagination.perPage}
        total={pagination.total}
        page={pagination.page}
        callback={(pg, perPage) =>
          setPagination({ ...pagination, page: pg, perPage })
        }
      />
    </div>
  );
}

export default CustomerDetailTransactionList;

const Order = ({ order, og }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  return (
    <div className="w-full flex  justify-between bg-white p-4 gap-3 rounded-md">
      <div className="flex flex-col md:flex-row justify-between flex-1">
        {order?.map(({ elements, width }, index) => (
          <div
            className={`w-full rounded-lg ${width || "flex-1"} ${
              !open && index !== 0 ? "hidden md:flex" : "flex"
            } flex-col ${
              open && "border-b pb-3"
            } mb-2 px-2 md:border-b-0 md:pb-0`}
            key={index}
          >
            {elements?.map((element, idx) => (
              <OrderContent element={element} key={idx} />
            ))}
          </div>
        ))}
      </div>
      <div
        className={`${
          //   bookingData?.status || og?.status ? "flex" : "hidden"
          ""
        } flex-col justify-between items-center `}
      >
        <button
          className="cursor-pointer p-2 relative "
          disabled={loading}
          onClick={() => setOpen(true)}
        >
          {loading ? (
            <div className="primaryLoader"></div>
          ) : (
            <img
              src="/IconMore.svg"
              alt=""
              className="h-5 object-contain relative"
            />
          )}
        </button>
      </div>
    </div>
  );
};
